import { useState } from "react";
import { Tag, ClockClockwise, Plus, Trash, ArrowRight } from "@phosphor-icons/react";

/**
 * Painel colapsável de HISTÓRICO de um pedido, com diff visual de mudanças
 * (itens adicionados/removidos/alterados, mudança de qty/copos/cores).
 * Extraído de OrderDetail.jsx.
 */
export default function HistoryPanel({ history }) {
  const [expanded, setExpanded] = useState({});
  const rev = (history || []).slice().reverse();
  return (
    <div className="border border-black bg-white" data-testid="history-panel">
      <div className="border-b border-black p-3 flex items-center gap-2">
        <ClockClockwise size={14} />
        <div className="overline text-zinc-500">HISTÓRICO</div>
      </div>
      <div className="p-3 space-y-3 max-h-[28rem] overflow-y-auto">
        {rev.length === 0 && <div className="text-xs text-zinc-400">Sem eventos.</div>}
        {rev.map((h, i) => {
          const hasDiff = !!h.diff;
          const isOpen = expanded[i];
          const stableKey = h.at || `history-${i}`;
          return (
            <div key={stableKey} className="border-b border-zinc-100 pb-3 last:border-b-0" data-testid={`history-${i}`}>
              <div className="flex items-start gap-2">
                <Tag size={12} className="mt-0.5 text-zinc-400 shrink-0" />
                <div className="flex-1 min-w-0">
                  <div className="font-mono text-[10px] text-zinc-500">{new Date(h.at).toLocaleString("pt-BR")}</div>
                  <div className="text-xs break-words"><strong>{h.actor}</strong> · {h.action}</div>
                  {hasDiff && (
                    <button onClick={() => setExpanded({ ...expanded, [i]: !isOpen })} className="text-[10px] underline mt-1 text-zinc-500">
                      {isOpen ? "ocultar" : "ver diff"}
                    </button>
                  )}
                </div>
              </div>
              {hasDiff && isOpen && (
                <div className="mt-2 ml-5 text-[11px] space-y-2" data-testid={`diff-${i}`}>
                  {h.diff.totals && (
                    <div className="font-mono text-[10px] bg-zinc-50 border border-zinc-200 p-2">
                      <div>itens: {h.diff.totals.before.items} → {h.diff.totals.after.items}</div>
                      <div>copos: <span className={h.diff.totals.after.cups > h.diff.totals.before.cups ? "text-[#00A300]" : "text-[#E60000]"}>
                        {h.diff.totals.before.cups} → {h.diff.totals.after.cups} ({h.diff.totals.after.cups - h.diff.totals.before.cups >= 0 ? "+" : ""}{h.diff.totals.after.cups - h.diff.totals.before.cups})
                      </span></div>
                    </div>
                  )}
                  {(h.diff.added_skus || []).map((s) => (
                    <div key={`a-${s}`} className="flex items-center gap-1 text-[#00A300] bg-green-50 border-l-2 border-[#00A300] pl-2 py-1">
                      <Plus size={10} weight="bold" /> <span className="font-mono">{s}</span> adicionado
                    </div>
                  ))}
                  {(h.diff.removed_skus || []).map((s) => (
                    <div key={`r-${s}`} className="flex items-center gap-1 text-[#E60000] bg-red-50 border-l-2 border-[#E60000] pl-2 py-1 line-through">
                      <Trash size={10} weight="bold" /> <span className="font-mono">{s}</span> removido
                    </div>
                  ))}
                  {(h.diff.changed || []).map((c) => (
                    <div key={`c-${c.sku}`} className="bg-yellow-50 border-l-2 border-[#FFC000] pl-2 py-1">
                      <div className="font-mono font-bold">{c.sku}</div>
                      {c.from.qty !== c.to.qty && (
                        <div className="flex items-center gap-1">
                          <span>qty:</span>
                          <span className="line-through text-zinc-400">{c.from.qty}</span>
                          <ArrowRight size={9} />
                          <strong>{c.to.qty}</strong>
                        </div>
                      )}
                      {c.from.cups !== c.to.cups && (
                        <div className="flex items-center gap-1">
                          <span>copos:</span>
                          <span className="line-through text-zinc-400">{c.from.cups}</span>
                          <ArrowRight size={9} />
                          <strong className={c.to.cups > c.from.cups ? "text-[#00A300]" : "text-[#E60000]"}>{c.to.cups}</strong>
                        </div>
                      )}
                      {JSON.stringify(c.from.color_breakdown) !== JSON.stringify(c.to.color_breakdown) && (
                        <div className="mt-1">
                          <div className="text-[10px] text-zinc-500">cores:</div>
                          <div className="text-[10px] line-through text-zinc-400">{(c.from.color_breakdown || []).map(b => `${b.color}:${b.qty}`).join(", ") || "(vazio)"}</div>
                          <div className="text-[10px] font-bold">{(c.to.color_breakdown || []).map(b => `${b.color}:${b.qty}`).join(", ") || "(vazio)"}</div>
                        </div>
                      )}
                    </div>
                  ))}
                </div>
              )}
            </div>
          );
        })}
      </div>
    </div>
  );
}
